import { FormGroup } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import Text from '../../../generic/Text';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { GeneralSettings } from '../../../../../shared/settings/general';

type Props = {
  settings: GeneralSettings;
  onUpdateSettings: (settings: Partial<GeneralSettings>) => void;
  isDisabled: boolean;
};

/**
 * General settings section for organization settings.
 * This section controls the organization title and billing email.
 */
const GeneralSection: VoidFunctionComponent<Props> = ({ settings, onUpdateSettings, isDisabled }) => {
  return (
    <>
      <Text.H3>General</Text.H3>
      <div>
        <FormGroup>
          <LabeledTextInput
            label="Organization Title"
            isRequired
            value={settings?.title}
            placeholder="Organization title"
            onChange={(title) => {
              onUpdateSettings({
                title,
              });
            }}
            isDisabled={isDisabled}
          />
        </FormGroup>
        <FormGroup>
          <LabeledTextInput
            type="email"
            label="Billing Email"
            value={settings?.email || ''}
            placeholder="Organization billing email"
            onChange={(email) => {
              onUpdateSettings({
                email,
              });
            }}
            isDisabled={isDisabled}
          />
        </FormGroup>
      </div>
    </>
  );
};

export default GeneralSection;
